<script>
import { mapGetters } from 'vuex';
import LoadIndicator from './LoadIndicator';
import Event from './Event';

export default {
    name: 'ContentEventsBlock',
    components: {
        LoadIndicator,
        Event
    },
    props: {
        data: Object,
    },
    data: () => {
        return {
            shownEvents: 5,
            totalEvents: 0,
        }
    },
    mounted() {
        this.$store.dispatch('loadAllEvents');
        this.shownEvents = parseInt(this.data.number_of_items);
    },
    methods: {
        onShowMore() {
            this.shownEvents += parseInt(this.data.number_of_items);
        },
        compare(a, b) {
            a = a.dates[0].date ? new Date(a.dates[0].date) : 0;
            b = b.dates[0].date ? new Date(b.dates[0].date) : 0;
            if (a > b){
                return 1;
            }
            if (a < b){
                return -1;
            }
            return 0;
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'getEventsIsLoading',
            events: 'getAllEvents',
        }),
        filteredEvents() {
            let data = [ ... this.events ];

            // if (this.events) {
            //     let featured = this.events.filter(item => item.featured);
            //     let notFeatured = this.events.filter(item => !item.featured);
            //     featured.sort(this.compare);
            //     notFeatured.sort(this.compare);

            //     data = [...featured, ...notFeatured];
            // }

            this.totalEvents = data.length;
            return data.slice(0, this.shownEvents);

        },
    }
};
</script>

<template>
    <div class="events-block">
        <h2 class="events-block__title" v-if="data.title" v-html="data.title"></h2>
        <div class="events-block__list">
            <div class="events-block__list__body">
                <event 
                    v-for="(event, i) in filteredEvents" 
                    v-bind:key="i"
                    v-bind="event.dates"
                    v-bind:dates="event.dates"
                    v-bind:title="event.post_title"
                    v-bind:description="event.description"
                    v-bind:organisation="event.organisation"
                    v-bind:link="event.link" 
                    v-bind:featured="event.featured" />

                <div class="events-block__list__no-items" 
                    v-if="!isLoading && filteredEvents.length === 0">
                        {{ $t('eventsBlock.noItems') }}
                </div>

                <load-indicator v-if="isLoading" />

            </div>

            <div class="events-block__list__footer">
                <a  class="events-block__list__load-more" 
                    v-if="totalEvents > shownEvents && !isLoading" 
                    v-on:click="onShowMore">{{ $t('eventsBlock.loadMore') }}
                </a>
            </div>
            
        </div>

    </div>
</template>

<style lang="scss" scoped>
.events-block__title {
    margin: 9.6rem 0 4.8rem;
    font-weight: 700;
    font-size: 3.2rem;
}

.events-block__list__body {
    border-top: 0.1rem solid rgba($color-primary, .15);
    border-bottom: 0.1rem solid rgba($color-primary, .15);
}
.events-block__list__no-items {
    padding: 3.2rem 0;
    text-align: center;
}
.event:last-child {
    border-bottom: none;
}
.load-indicator {
    padding: 3.2rem 0;
    text-align: center;
}
.events-block__list__footer {
    padding: 0.8rem 0;
    text-align: center;
}
.events-block__list__load-more {
    font-size: 1.4rem;
    color: $color-secondary;
    letter-spacing: 0.02857142857em;
    line-height: 1;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
}
</style>
